// FiboPromptTree/badges/Badge.tsx
import { CurlyBracesIcon } from "../../../../assets/images/icons/CurlyBracesIcon";
import type { JSONValue } from "../../../../models/fibo";
import { isArr, isObj } from "../../../../utils/fiboLabs";
import styles from "./FiboPromptTree.module.scss";

export function Badge({ value }: { value?: JSONValue }) {
	return (
		<span className={styles.badge}>
			<CurlyBracesIcon className={styles.badgeIcon} />
			{isArr(value) ? value.length : isObj(value) && Object.keys(value).length}
		</span>
	);
}
